module.exports = __webpack_public_path__ + "img/arrow-right-circle.1026c890.svg";